import { IconSVG } from '../types';

export const VideoLibrary = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 40 40"
    style={style}
  >
    <mask
      id="mask0_4013_5961"
      style={{ maskType: 'alpha' }}
      width="60"
      height="60"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H40V40H0z" />
    </mask>
    <g mask="url(#mask0_4013_5961)">
      <path
        fill="currentColor"
        d="M19.166 24.167l11.667-7.5-11.667-7.5v15zM13.333 30a3.21 3.21 0 01-2.354-.979 3.21 3.21 0 01-.98-2.354v-20c0-.917.327-1.702.98-2.354a3.21 3.21 0 012.354-.98h20a3.21 3.21 0 012.354.98 3.21 3.21 0 01.98 2.354v20a3.21 3.21 0 01-.98 2.354 3.21 3.21 0 01-2.354.98h-20zm0-3.333h20v-20h-20v20zm-6.667 10a3.21 3.21 0 01-2.354-.98 3.21 3.21 0 01-.979-2.353V10h3.333v23.334H30v3.333H6.666z"
      />
    </g>
  </svg>
);
